import { cn } from "@/lib/utils";

export const APP_STORE_URL = "https://apps.apple.com/de/app/ncrechner/id1493609200";
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.ncrechner&hl=de";

const AppleGlyph = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 24 24" className={cn("w-5 h-5 fill-current shrink-0", className)} aria-hidden="true">
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
  </svg>
);

const PlayGlyph = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 24 24" className={cn("w-[18px] h-[18px] fill-current shrink-0", className)} aria-hidden="true">
    <path d="M22.018 13.298l-3.919 2.218-3.515-3.493 3.543-3.521 3.891 2.202a1.49 1.49 0 0 1 0 2.594zM1.337.924a1.486 1.486 0 0 0-.112.568v21.017c0 .217.045.419.124.6l11.155-11.087L1.337.924zm12.207 10.065l3.258-3.238L3.45.195a1.466 1.466 0 0 0-.946-.179l11.04 10.973zm0 2.067l-11 10.933c.298.036.612-.016.906-.183l13.324-7.54-3.23-3.21z" />
  </svg>
);

type Variant = "ink" | "paper" | "outline-light";

const variantClasses: Record<Variant, string> = {
  ink: "bg-ink text-paper hover:bg-accent",
  paper: "bg-paper text-ink hover:bg-paper-deep",
  "outline-light": "border border-white/20 text-paper hover:bg-white/10",
};

function StoreButton({
  href,
  topLabel,
  storeName,
  glyph,
  variant,
}: {
  href: string;
  topLabel: string;
  storeName: string;
  glyph: React.ReactNode;
  variant: Variant;
}) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        "flex items-center gap-3 px-4 py-1.5 rounded-full min-h-[40px] cursor-pointer transition-colors duration-200",
        variantClasses[variant]
      )}
    >
      {glyph}
      <span className="text-left leading-none">
        <span className="block font-semibold text-sm">{storeName}</span>
      </span>
    </a>
  );
}

export default function StoreButtons({
  variant = "ink",
  className,
}: {
  variant?: Variant;
  className?: string;
}) {
  return (
    <div className={cn("flex flex-wrap gap-3", className)}>
      <StoreButton
        href={APP_STORE_URL}
        topLabel="Laden im"
        storeName="App Store"
        glyph={<AppleGlyph />}
        variant={variant}
      />
      <StoreButton
        href={PLAY_STORE_URL}
        topLabel="Jetzt bei"
        storeName="Google Play"
        glyph={<PlayGlyph />}
        variant={variant}
      />
    </div>
  );
}
